export default {
	// fields msgs
	text: 'Vyplňte Popis',
	documentType: 'Vyplňte Typ dokumentu',
	personIn: 'Vyplňte Rodné číslo/IČO, které je pro vybraný typ dokumentu povinné',
	businessCaseNo: 'Vyplňte Číslo obchodního případu, které je pro vybraný typ dokumentu povinné',
	name: 'Vyplňte Název nebo Jméno a Příjmení',
	taskType: 'Vyplňte Název příležitosti',
	taskSubTypeId: 'Vyplňte Důvod kontaktování klienta / Podtyp úkolu / Podtyp příležitosti',
	fulfillDate: 'Vyplňte Termín splnění',
	warningDate: 'Vyplňte Termín upozornění',
	municipality: 'Vyplňte Obec',
	zipCode: 'Vyplňte PSČ',
	emailOrPhoneNumber: 'Vyplňte Telefon nebo E-mail',
	phoneNumber: 'Vyplňtě Telefon',
	radio: 'Vyplňte Nastavení řešitele',
	loginOrSellerInOrUserSurname: 'Vyplňte Login uživatele nebo Získatelské/Agenturní číslo nebo Příjmení uživatele',
	superior: 'Vyplňte Jméno uživatele',
	subordinate: 'Vyplňte Jméno uživatele',
	channel: 'Vyplňte Kanál',
	region: 'Vyplňte Region',
	agency: 'Vyplňte Oblast',
	manager: 'Vyplňte Manažer',
	backOfficeSegment: 'Vyplňte Řešenou oblast',
	backOfficeWithGPPolicyNoAndAttachments: 'Úkol Backoffice na smlouvu z bývalé Generali nemůže obsahovat přílohy.',
	openLetterDate: 'Vyplňte otevírací dopisy',
	orderStartDate: 'Vyplňte Od',
	orderEndDate: 'Vyplňte Do',
	templateName: 'Vyplňte Název šablony',
	atLeastOneOfRequiredFields: 'Alespoň jedno ze zvýrazněných kritérií musí být vyplněno.',
	atLeastOneOfFilterCriteriaFields: 'Alespoň jedno z vyhledávacích kritérií musí být vyplněno.',
	statType: 'Vyplňte Typ statistiky',
	dateFrom: 'Vyplňte Období statistiky od',
	dateTo: 'Vyplňte Období statistiky do',
	campaignName: 'Vyplňte Název kampaně',
	communicationName: 'Vyplňte Název komunikace',
	campaignType: 'Vyplňte Typ kampaně',
	startDate: 'Vyplňte Začátek kampaně',
	endDate: 'Vyplňte Konec kampaně',

	// other related msgs
	saveTemplateMaxAmountReached:
		'Je umožněno uložit pouze {{maxCount}} šablon, před uložením prosím smažte nepoužívané šablony.',
	nonUniqueSolver: 'Upřesněte podmínky, aby zadaným informacím o řešiteli odpovídal právě jeden uživatel.',
};
